import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { initialDataList } from '@interfaces/common/common.Interface'

export interface BangLuongState {
  bangLuongList?: any
  kyLuongList?: any
  tongHopList?: any
  giaoNhanList?: any
  reloadBangLuongList?: string | null
}

const initialState: BangLuongState = {
  bangLuongList: initialDataList,
  kyLuongList: initialDataList,
  tongHopList: initialDataList,
  giaoNhanList: initialDataList,
  reloadBangLuongList: null,
}

export const bangLuongDucks = createSlice({
  name: 'bangLuong',
  initialState,
  reducers: {
    // Bảng lương
    layDanhSachBangLuong: (state: RootState, action: PayloadAction<any>) => {
      state.bangLuongList = { loading: true, queryStr: action.payload }
    },
    layDanhSachBangLuongThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.bangLuongList = { loading: false, ...action.payload }
    },
    layDanhSachBangLuongThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.bangLuongList = { loading: false, ...action.payload }
    },

    // Kỳ lương
    layDanhSachKyLuong: (state: RootState, action: PayloadAction<any>) => {
      state.kyLuongList = { loading: true, queryStr: action.payload }
    },
    layDanhSachKyLuongThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.kyLuongList = { loading: false, ...action.payload }
    },
    layDanhSachKyLuongThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.kyLuongList = { loading: false, ...action.payload }
    },

    // Tổng hợp
    layDanhSachTongHop: (state: RootState, action: PayloadAction<any>) => {
      state.tongHopList = { loading: true, queryStr: action.payload }
    },
    layDanhSachTongHopThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.tongHopList = { loading: false, ...action.payload }
    },
    layDanhSachTongHopThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.tongHopList = { loading: false, ...action.payload }
    },

    // Giao nhận
    layDanhSachGiaoNhan: (state: RootState, action: PayloadAction<any>) => {
      state.giaoNhanList = { loading: true, queryStr: action.payload }
    },
    layDanhSachGiaoNhanThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.giaoNhanList = { loading: false, ...action.payload }
    },
    layDanhSachGiaoNhanThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.giaoNhanList = { loading: false, ...action.payload }
    },

    datTaiLaiDanhSachBangLuong: (state: RootState) => {
      state.reloadBangLuongList = String(Date.now())
    },
  },
})

export const {
  layDanhSachBangLuong,
  layDanhSachBangLuongThanhCong,
  layDanhSachBangLuongThatBai,
  layDanhSachKyLuong,
  layDanhSachKyLuongThanhCong,
  layDanhSachKyLuongThatBai,
  layDanhSachTongHop,
  layDanhSachTongHopThanhCong,
  layDanhSachTongHopThatBai,
  layDanhSachGiaoNhan,
  layDanhSachGiaoNhanThanhCong,
  layDanhSachGiaoNhanThatBai,
  datTaiLaiDanhSachBangLuong,
} = bangLuongDucks.actions

export default bangLuongDucks.reducer
